export default {
	INITIAL: 'initial',
	SUBMITTING: 'submitting',
}
